export default __webpack_public_path__ + "6c6c3490d8910e882ee9bf56b31635e8.png";